<template>
    <v-container class="axa-box-general" v-if="programDisabled.state && 1==2">
        <v-row>
            <v-col cols="11">
                <h2>{{programDisabled.message}}</h2>
            </v-col>
        </v-row>
    </v-container>
    <v-container class="axa-box-general" v-else>
        <axa-loader fullscreen v-show="isLoading" />
        <v-row>
            <v-col cols="11">
                <h4>İşlem Yetkileri</h4>
            </v-col>
        </v-row>
        <v-row v-if="userMethods != null && userMethods.length > 0">
            <v-col cols="11">
                <v-autocomplete
                    append-icon="mdi-chevron-down"
                    :items="userMethods"
                    item-text="PROGNAME"
                    item-value="PROGNAME"
                    placeholder="İşlem seçiniz..."
                    label="İşlem Seçimi"
                    v-model="selectedMethodName"
                    class="axa-select"
                    @change="handleChangeMethodSelection"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="11">
                <p>Yapabileceğiniz herhangi bir işlem yetkiniz bulunmamaktadır.</p>
            </v-col>
        </v-row>
     
        <v-row>
            <v-col cols="11">
                <v-card>
                    <v-tabs v-model="tab">
                        <v-tab key="tab1">İşlem Parametreleri</v-tab>
                        <v-tab v-if="batchingEnabled" key="tab2">Toplu İşlem</v-tab>
                    </v-tabs>
                    <div v-if="selectedMethod != null" style="width: 100%; height: 100%; padding: 6px 28px;">
                        <v-tabs-items v-model="tab">
                            <v-tab-item key="tab1">
                                <v-container>
                                    <v-row v-for="(param, pIndex) in selectedMethod.MethodParameters" :key="'method-'+pIndex">
                                        <v-col cols="11">
                                            <v-text-field 
                                                v-if="param.PARAMETERTYPE == 'VARCHAR2'"
                                                :label="param.PARAMETER_NAME"
                                                v-model="selectedMethod[param.PARAMETER_NAME]"
                                            ></v-text-field>
                                            <v-text-field 
                                                v-else-if="param.PARAMETERTYPE == 'NUMBER'" 
                                                type="number"
                                                :label="param.PARAMETER_NAME"
                                                v-model="selectedMethod[param.PARAMETER_NAME]"
                                            ></v-text-field>
                                            <axa-date-picker v-else label="TANZİM BAS."
                                                :label="param.PARAMETER_NAME"
                                                v-model="selectedMethod[param.PARAMETER_NAME]"/>
                                        </v-col> 
                                    </v-row>
                                    <v-row>
                                        <v-col cols="11">
                                            <v-text-field v-model="description" label="AÇIKLAMA"/>
                                        </v-col>
                                    </v-row>
                                   
                                    <v-row class="mt-3">
                                        <v-col cols="11">
                                            <v-btn class="axa-btn type-dark mr-3" @click="callExecuteUserMethod">ÇALIŞTIR</v-btn>
                                            <v-btn class="axa-btn type-dark mr-3" :disabled="!csvExportEnabled" @click="handleExportExcelButtonClick">EXCEL</v-btn>
                                        </v-col>
                                    </v-row>
                                     <v-row v-if="showResultsPanel">
                <v-col cols="11">
                    <h5 class="mb-4">SONUÇLAR</h5>
                    <v-data-table :headers="results.headers" :items="results.rows" :items-per-page="100"  
                                    :footer-props="{'items-per-page-options': [5, 10, 20, 50, 100]}" 
                                    item-key="index" loading-text="Yükleniyor..." :search="search">
                        <template v-slot:top>
                            <v-toolbar flat class="table-toolbar table-filter">
                                <v-spacer></v-spacer>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Ara"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item`]="{ item }">
                            <tr>
                                <td v-for="header in results.headers" :key="header.value">
                                    <span v-if="item[header.value] && item[header.value].length > 200"
                                        @click="openDialog(item[header.value], header.text)">
                                        {{ item[header.value].substring(0, 200) }}...
                                    </span>
                                    <span v-else>
                                        {{ item[header.value] }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-dialog v-model="dialog" max-width="800px">
                        <v-card>
                            <v-card-title class="headline">
                                {{ dialogHeader }}
                                <axa-copy-button :copyData="dialogText" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click="dialog = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-text v-if="dialogText.startsWith('<?xml')">
                                <pre v-text="formatXml(dialogText)"></pre>
                            </v-card-text>
                            <v-card-text v-else-if="dialogText.startsWith('{')">
                                <pre v-text="formatJson(dialogText)"></pre>
                            </v-card-text>
                            <v-card-text v-else>
                                <p>{{ dialogText }}</p>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item v-if="batchingEnabled" key="tab2">
                                <div class="batch-run-container">
                                    <input
                                        @change="handleChangeFileUpload($event)"
                                        accept=".xlsx, .xls"
                                        type="file" ref="hiddenFileInput" id="hiddenFileInput" style="display: none;"
                                    />
                                    <div 
                                        class="file-upload-overlay"
                                        @drop.prevent="(e) => getDroppedFile(e)"
                                        @dragover.prevent="dragover = true"
                                        @dragenter.prevent="dragover = true"
                                        @dragleave.prevent="dragover = false"
                                        :class="[{'dragover' : dragover}, {'reading-files': isReadingFiles}]"
                                    >
                                        <div v-if="dragover == true" class="batch-run-loading batch-dragover">
                                            <axa-icon name="file-drop"></axa-icon>
                                            <p>Dosyayınızı bıraktığınızda içeriğin uygunluğunu değerlendirmeye başlayacağız.</p>
                                        </div>
                                        <div  @click="openFileDialog" v-else-if="batchStatus == 'idle'" class="batch-run-loading">
                                            <axa-icon name="file-upload-2"></axa-icon>
                                            <p>Toplu işlem yapmak için excel dosyanızı buraya bırakabilirsiniz ya da buraya tıklayarak seçip yükleyebilirsiniz.</p>
                                        </div>
                                        <div v-else-if="batchStatus == 'processing'" class="batch-run-loading batch-processing">
                                            <v-progress-circular 
                                                class="batch-progress" 
                                                color="primary" 
                                                size="96"
                                                indeterminate
                                            ></v-progress-circular>
                                            <p>Dosyanız işleniyor...</p>
                                        </div>
                                        <div v-else-if="batchStatus == 'running'" class="batch-run-loading batch-running">
                                            <v-progress-circular 
                                                class="batch-progress" 
                                                color="warning" 
                                                size="96"
                                                rotate="-90"
                                                :value="batchPercentage">
                                                % {{ batchPercentage }}
                                            </v-progress-circular>
                                            <p>İşlemler yürütülüyor...</p>
                                            <span>Dosyanızdaki {{ allRowsCount }} satırdan {{ processedRowsCount }} tanesi işlendi.</span>
                                        </div>
                                        <div v-else-if="batchStatus == 'ready'" class="batch-run-loading batch-ready">
                                            <axa-icon name="kick-start"></axa-icon>
                                            <p>Dosya içeriğiniz bu işlemi toplu olarak çalıştırmak için uygun.</p>
                                            <button class="btn-special" @click="kickOffBatchProcess">
                                                <axa-icon name="play-filled"></axa-icon>
                                                Toplu İşlemi Başlat
                                            </button>
                                        </div>
                                        <div v-else-if="batchStatus == 'error'" class="batch-run-loading batch-error">
                                            <axa-icon name="broken-file"></axa-icon>
                                            <p>Dosyanızın içeriği çalıştırmak istediğiniz işlemin bütün kriterlerini karşılamalıdır.</p>
                                            <div class="batch-row mr-2" style="justify-content: center;">
                                                <button v-if="1==1" class="btn-special" @click="clearBatchProcess()">
                                                    <axa-icon name="play-filled"></axa-icon>
                                                    Yeni Toplu İşlem Yap
                                                </button>
                                            </div>
                                        </div>
                                        <div v-else-if="batchStatus == 'completed'" class="batch-run-loading batch-completed">
                                            <div class="batch-header-row">
                                                <axa-icon name="success-circle"></axa-icon>
                                                <p>Toplu çalıştırma tamamlandı!</p>
                                            </div>
                                            <div class="batch-row">
                                                <axa-icon name="warning-fill" class="batch-warning"></axa-icon>
                                                <p>Toplam {{ allRowsCount }} satır veri işlendi.</p>
                                                <p v-if="problematicRowsCount > 0">{{ problematicRowsCount }} satır veri eksik ya da hatalı olduğundan dolayı işleme dahil edilmedi.</p>
                                            </div>
                                            <div class="batch-row">
                                                <axa-icon name="success-circle" class="batch-success"></axa-icon>
                                                <p>Toplu işlemlerin istediğiniz gibi sonuçlandığından emin olmak için lütfen sonuç dosyasını gözden geçirin.</p>
                                            </div>
                                            <!--
                                            <div class="batch-row">
                                                <v-progress-circular 
                                                    class="batch-progress" 
                                                    color="warning" 
                                                    size="32"
                                                    rotate="-90"
                                                    :value="batchPercentage">
                                                </v-progress-circular>
                                                <p>Başarı yüzdesi %{{ batchPercentage }}</p>
                                            </div>
                                            <div class="batch-row">
                                                <axa-icon name="success-circle" class="batch-success"></axa-icon>
                                                <p>Tüm satırların {{ succeedRowsCount }} tanesi başarılı oldu.</p>
                                            </div>
                                            -->
                                            <div v-if="failedRowsCount > 0" class="batch-row">
                                                <axa-icon name="error-fill" class="batch-error"></axa-icon>
                                                <p>{{ failedRowsCount }} satıra ait işlem başarısız oldu.</p>
                                            </div>
                                            <!--
                                            <div v-if="problematicRowsCount > 0" class="batch-row">
                                                <axa-icon name="warning-fill" class="batch-warning"></axa-icon>
                                                <p>{{ problematicRowsCount }} satır eksik ya da hatalı bilgiden dolayı toplu işleme dahil edilmedi.</p>
                                            </div>
                                            -->
                                            <div class="mt-5 batch-row">
                                                <button v-if="1==1" class="btn-special new-batch-process mr-4" @click="clearBatchProcess()">
                                                    <axa-icon name="play-filled"></axa-icon>
                                                    Yeni Toplu İşlem Yap
                                                </button>
                                                <button v-if="1==1" class="btn-special download-excel-template" @click="exportBatchResultsAsExcel()">
                                                    <axa-icon name="file-excel"></axa-icon>
                                                    İşlem Sonuçlarını İndir
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <v-card v-if="batchStatus == 'completed' && failedRowsCount > 0" class="rows-datagrid">
                                        <h3>Hatalı Sonuçlanan İşlemler</h3>
                                        <table cellspacing="4" border="1">
                                            <thead>
                                                <tr>
                                                    <th
                                                        v-for="(param, pIndex) in selectedMethod.MethodParameters" 
                                                        :key="'failed-rows-header-'+pIndex">{{ param.PARAMETER_NAME }}</th>
                                                    <th>Problem</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, rowIndex) in this.batchData.failed" :key="'failed-rows-' + rowIndex">
                                                    <td v-for="(column, columnIndex) in row" :key="'failed-rows-' + rowIndex + '-column-' + columnIndex">{{column}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </v-card>
                                    <div v-if="batchStatus == 'completed' && problematicRowsCount > 0" class="rows-datagrid">
                                        <h3>Toplu İşlem Dışı Kalan Satırlar</h3>
                                        <table cellspacing="4" border="1">
                                            <thead>
                                                <tr>
                                                    <th
                                                        v-for="(param, pIndex) in selectedMethod.MethodParameters" 
                                                        :key="'problematic-rows-header-'+pIndex">{{ param.PARAMETER_NAME }}</th>
                                                    <th>Problem</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, rowIndex) in this.batchData.problematic" :key="'problematic-rows-' + rowIndex">
                                                    <td v-for="(column, columnIndex) in row" :key="'problematic-rows-' + rowIndex + '-column-' + columnIndex">{{column}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="data-requirements">
                                        <h3>Gereksinimler</h3>
                                        <ul>
                                            <li>Buraya sadece excel yükleyebilirsiniz.</li>
                                            <li>
                                                Yüklediğiniz tabloda, yapacağınız işlemin bütün parametreleri kolon olarak yer almalıdır.
                                            </li>
                                            <li>
                                                Toplu işlem için yüklemeniz gereken tablo örneği aşağıda yer almaktadır.
                                            </li>
                                            <li>
                                                Aşağıda gösterilen örnek tablo yukarıda seçtiğiniz işlem için gerekli tabloyu temsil etmektedir.
                                            </li>
                                            <li>
                                                Yüklediğiniz tabloda hiçbir hücre boş bırakılmamalıdır. Boş bırakılmış hücreye sahip satırlar yok sayılacaktır.
                                            </li>
                                            <li>
                                                Tablonuzda yer alan veriler, ilgili parametrelerin veri formatına uygun olmalıdır. Aksi halde bu satır yok sayılacaktır.
                                            </li>
                                            <li>
                                                Örneğin; poliçe numarası numerik olmalıdır. Tarih verileri formatı GÜN/AY/YIL şeklinde olmalıdır.
                                            </li>
                                        </ul>
                                        <h3>Örnek Tablo</h3>
                                        <p>Excel dosyanız aşağıdaki gibi görünmelidir. Ayrıca seçtiğiniz işleme ait excel şablonunu indirebilir ve kendi verilerinizle doldurabilirsiniz.</p>
                                        <button v-if="1==1" class="btn-special download-excel-template mb-5" @click="downloadExcelTemplate()">
                                            <axa-icon name="file-excel"></axa-icon>
                                            Excel Şablonu İndir
                                        </button>
                                        <div class="mb-5"></div>
                                        <table class="example-sheet mt-5" cellspacing="4" border="1">
                                            <thead>
                                                <tr>
                                                    <th 
                                                        v-for="(param, pIndex) in selectedMethod.MethodParameters" 
                                                        :key="'method-param-cell'+pIndex">
                                                            {{ param.PARAMETER_NAME }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td
                                                        v-for="(param, pIndex) in selectedMethod.MethodParameters" 
                                                        :key="'method-data-cell'+pIndex"
                                                    >
                                                        {{ selectedMethod[param.PARAMETER_NAME] || '...' }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                        <v-spacer></v-spacer>
                    </div>
                    <div v-else style="width: 100%; height: 100%; padding: 6px 28px;">
                        <p>Lütfen yukarıdan yapmak istediğiniz işlemi seçiniz</p>
                    </div>
                </v-card>
            </v-col>
        </v-row>
       
       
        <v-snackbar v-model="snackbar.state" :timeout="snackbar.timeout" :color="'error'" centered>
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';
import { eventBus } from '@/main';
import * as SheetJS from 'xlsx';
import readXlsxFile from 'read-excel-file'
import moment from 'moment';

export default {
    data: () => ({
        tab: null,
        dragover: false,
        isReadingFiles: false,
        batchStatus: 'idle',
        batchProcess: {
            total: 0,
            processed: 0,
            success: 0,
            failed: 0,
            unprocessable: 0
        },
        batchParamsMap: {},
        batchData: {
            all: [],
            failed: [],
            problematic: [],
            success: [],
        },
        batchFile: null,
        userMethods: null,
        selectedMethodName: null,
        selectedMethod: null,
        description: '',
        initialResults: {
            headers: [],
            rows: []
        },
        results: {
            headers: [],
            rows: []
        },
        programDisabled: {
            state: false,
            message: 'Bu programı kullanma yetkiniz yoktur!',
        },
        snackbar: {
            state: false,
            message: '',
            timeout: 5000,
            anchor: 'center | center'
        },
        isLoading: false,
        dialog: false,
        dialogText: '',
        dialogHeader: '',
        search: '',
    }),
    computed: {
        batchingEnabled () { 
            
            const batchingAllowedMethods = [
                "PRIM_UPDATE_KAS",
                "VADE_BASI_SONU_GUNCELLE",
                "ISTATISTIK_UPDATE",
                "HATA_TEKLIF",
                "TOPLUOTORIZASYONONAYVER",
                "GET_UAVT_DETAY",
                "FILO_KASKO_VADE_GUNCELLE",
                "FILO_KASKO_BEDEL_GUNCELLE",
                "FILO_KASKO_SORU_GUNCELLE",
                "FILO_KASKO_ODEME_PLANI_GUNCELLE_GM",
                "FILO_KASKO_KOMISYON_GUNCELLE",
                "FILO_KASKO_KOMISYON_GUNCELLE_GM",
                "FILO_KASKO_BRUT_FIYAT_GUNCELLE",
                "FILO_KASKO_BRUT_PRIM_GUNCELLE",
				"FILO_KASKO_OTORIZASYON_VER",
                "FILO_KASKO_BILGI_GUNCELLE",
                "FILO_KASKO_ODEME_PLANI_GUNCELLE"
            ];

            return this.selectedMethod != null && batchingAllowedMethods.indexOf(this.selectedMethod.PROGNAME) > -1;
        },
        succeedRowsCount() { return this.batchData.success.length; },
        failedRowsCount() { return this.batchData.failed.length; },
        problematicRowsCount() { return this.batchData.problematic.length; },
        processedRowsCount() { return this.succeedRowsCount + this.failedRowsCount + this.problematicRowsCount },
        allRowsCount() { return this.batchData.all.length; },
        batchPercentage() { return Math.floor((this.succeedRowsCount * 100) / this.allRowsCount) },
        csvExportEnabled() { return this.results.headers.length > 0 && this.results.headers[0].name != 'SONUC' },
        excelExportEnabled() { return this.results.headers.length > 0 && this.results.headers[0].name != 'SONUC' },
        showResultsPanel() { return this.results.headers.length > 0 }
    },
    methods: {
        ...mapActions([
            'getUserMethods',
            'executeUserMethod'
        ]),
        ...mapGetters([
            'getUserCanAccessTeknikAdmin'
        ]),
        /* file upload method */
        getFileExt(fileName) {
            return fileName.split('.').pop()?.toLowerCase();
        },
        isFileAllowed(filename) {
            var allowedExtensions = ["xlsx", "xls"]
            var fileExt = this.getFileExt(filename)
            return allowedExtensions.indexOf(fileExt) > -1;
        },
        getDroppedFile(e) {
            this.batchStatus = 'processing';
            this.dragover = false;
            
            const file = e.dataTransfer.files[0];
            this.changeFileUpload(file);
        },
        changeFileUpload(file) {
            if (file.name.lastIndexOf('.') <= 0) {
                this.batchStatus = 'idle';
                return;
            }

            if(!this.isFileAllowed(file.name)) {
                this.batchStatus = 'idle';
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener('load', () => {
                this.batchFile = null;
                this.batchFile = {
                    FileSize: String(file.size),
                    FileName: file.name,
                    ContentType: file.type,
                    Body: reader.result.split(',').pop(),
                    Subject: file.name,
                };
                
                setTimeout(() => { this.processExcelFile(file) }, 2000);
            });

            reader.onerror = status => {
                this.isReadingFiles = false;
                this.batchStatus = 'processing'
            };
            reader.onloadend = () => {
                this.isReadingFiles = false;
                this.batchStatus = 'processing'
            };

            this.isReadingFiles = false;
        },
        handleChangeFileUpload(event) {
            this.changeFileUpload(event.target.files[0]);
        },
        openFileDialog() {
            window.document.getElementById('hiddenFileInput').click()
        },
        processExcelFile(file) {
            readXlsxFile(file).then((rows) => {
               

                if(rows.length < 2) {
                    this.batchStatus = 'error';
                    return;
                }

                const columns = rows[0];
                const expectedColumnCount = this.selectedMethod.MethodParameters.length;
                var foundColumnCount = 0;

                this.selectedMethod.MethodParameters.forEach((param, paramIndex) => {
                    const foundIndex = columns.indexOf(param.PARAMETER_NAME);
                    if(foundIndex > -1) {
                        foundColumnCount++;
                        this.batchParamsMap[param.PARAMETER_NAME] = foundIndex;
                    }
                });

                if(foundColumnCount != expectedColumnCount) {
                    this.batchStatus = 'error';
                    return;
                }

                this.batchData.all = rows.slice(1);
                this.batchStatus = 'ready';
            });
        },
        downloadExcelTemplate()
        {
            let excelColumnsHeaders = [];
            let excelEmptyRowContent = [];
            let excelContent = [];
            this.selectedMethod.MethodParameters.map((param, paramIndex) => {
                excelColumnsHeaders.push(param.PARAMETER_NAME);
                excelEmptyRowContent.push('');
            });

            excelContent.push(excelColumnsHeaders);
            excelContent.push(excelEmptyRowContent);
            
            var fileName = this.selectedMethod.PROGNAME + " İşlem Şablonu.xlsx";
            this.downloadExcelFile(fileName, excelContent);
        },
        async kickOffBatchProcess() {

            const sleepNow = (delay) => new Promise((resolve) => setTimeout(resolve, delay))

            this.batchStatus = 'running';
            
            const batchSize = 20;
            const batchCount = Math.ceil(this.batchData.all.length / batchSize);
            for(var batchStep = 0; batchStep < batchCount; batchStep++) 
            {
                const paramObjArray = [];

                for(var subIndex = 0; subIndex < batchSize; subIndex++) 
                {
                    const rowIndex = parseInt((batchStep * batchSize) + subIndex);
                    if(rowIndex == this.batchData.all.length)
                        break;

                    const row = this.batchData.all[rowIndex];
                    const paramsObj = [];

                    for(const[obKey, obValue] of Object.entries(this.batchParamsMap))
                    {
                        const methodParam = this.selectedMethod.MethodParameters.find(m => m.PARAMETER_NAME == obKey);

                        var columnValue = row[obValue];
                        if(columnValue == null || columnValue == undefined) 
                        {
                            this.batchData.problematic.push([
                                ...row,
                                (rowIndex + 1) + ". satır, " + obKey + " parametresi değeri boş."
                            ]);
                            break;
                        }

                        columnValue = columnValue.toString().trimEnd().trimStart();
                        if(methodParam.PARAMETERTYPE == 'VARCHAR2' && columnValue.length == 0)
                        {
                            this.batchData.problematic.push([
                                ...row,
                                (rowIndex + 1) + ". satır, " + obKey + " parametresi değeri boş."
                            ]);
                            break;
                        } 
                        else if(methodParam.PARAMETERTYPE == "NUMBER" && isNaN(columnValue))
                        {
                            this.batchData.problematic.push([
                                ...row,
                                (rowIndex + 1) + ". satır, " + obKey + " parametre değeri numerik olmalıdır."
                            ]);
                            break;
                        } 
                        else if(methodParam.PARAMETERTYPE == "DATE" && isNaN(new Date(columnValue)))
                        {
                            this.batchData.problematic.push([
                                ...row,
                                (rowIndex + 1) + ". satır, " + obKey + " parametre değeri tarih formatına uygun değildir. (GÜN/AY/YIL)."
                            ]);
                            break;
                        }
                        else if(methodParam.PARAMETERTYPE == "DATE" && !isNaN(new Date(columnValue)))
                        {
                            columnValue = moment(columnValue).format("DD.MM.YYYY");
                        }

                        paramsObj.push({
                            Name: obKey,
                            Value: columnValue,
                            InputType: methodParam.PARAMETERTYPE,
                            DirectionType: "IN"
                        })
                    };

                    if(paramsObj.length == this.selectedMethod.MethodParameters.length) 
                    {
                        paramObjArray.push({
                            params: paramsObj,
                            actualRow: row
                        });
                    }
                }

                await this.makePromiseAll(paramObjArray);
                await sleepNow(1000);
            }

            this.batchStatus = 'completed';
           
        },
        async makePromiseAll(paramObjArray) {

            const methodName = this.selectedMethod.PROGNAME
            const isFunc = this.selectedMethod.IsFunc

            let func = async function() {
                const responses = await Promise.allSettled(
                    paramObjArray.map(async paramsObj => {
                        const executionRequestPayload = {
                            MethodName: methodName,
                            IsFunc: isFunc,
                            Description: "AxaTek TeknikAdmin Toplu İşlem",
                            Parameters: paramsObj.params
                        };

                        const apiCallResult = await this.$store.dispatch('executeUserMethod', executionRequestPayload)
                        if(apiCallResult.IsSuccess == false) {
                            this.batchData.failed.push([
                                ...paramsObj.actualRow,
                                apiCallResult.Mesajlar[0].Mesaj || (apiCallResult.MessageCode + " - " + apiCallResult.Error)
                            ]);
                        }
                        else
                        {
                            let resultMessage = "";
                            const resultAsJson = JSON.parse(apiCallResult.Data);

                            if(resultAsJson != null && resultAsJson.length == 1) {
                                if('SONUC' in resultAsJson[0])
                                    resultMessage = resultAsJson[0]["SONUC"]
                            }

                            const paramsWithMessage = [
                                ...paramsObj.actualRow,
                                resultMessage
                            ];

                            this.batchData.success.push(paramsWithMessage);
                        }

                        return apiCallResult;
                    })
                );
            }.bind(this);
            
            await func();
        },
        async executeMethodApiCall(paramsObj) {
            const executionRequestPayload = {
                MethodName: this.selectedMethod.PROGNAME,
                IsFunc: this.selectedMethod.IsFunc,
                Description: "AxaTek TeknikAdmin Toplu İşlem",
                Parameters: paramsObj
            };

            const response = await this.$store.dispatch('executeUserMethod', executionRequestPayload);
            return response;
        },
        async callGetUserMethods() {
            this.isLoading = true;
            const response = await this.$store.dispatch('getUserMethods');
            this.isLoading = false;

            if(response.IsSuccess == false) {
                this.programDisabled.state = true;
                this.programDisabled.message = response.Mesajlar[0].Mesaj;
                return;
            }

            this.programDisabled.state = false;
            this.userMethods = response.Data.PackageMethods;
        },
        async callExecuteUserMethod() {
            this.isLoading = true;

            const executionRequestPayload = {
                MethodName: this.selectedMethod.PROGNAME,
                IsFunc: this.selectedMethod.IsFunc,
                Description: this.description,
                Parameters: []
            };

            this.selectedMethod.MethodParameters.forEach((param, index) => {
                executionRequestPayload.Parameters.push({
                    Name: param.PARAMETER_NAME,
                    Value: this.selectedMethod[param.PARAMETER_NAME],
                    InputType: param.PARAMETERTYPE,
                    DirectionType: param.IN_OUT
                })
            });

            const response = await this.$store.dispatch('executeUserMethod', executionRequestPayload);
            this.isLoading = false;

            if(response.IsSuccess == false) {
                
                this.snackbar = {
                    state: true,
                    message: response.Mesajlar[0].Mesaj || (response.MessageCode + " - " + response.Error)
                };

                return;
            }

            eventBus.$emit('isLoading', { loading: false });
            this.programDisabled.state = false;

            if(response.Data != null) {
                const resultJson = JSON.parse(response.Data);
                this.results.headers = Object.keys(resultJson[0]).map((m, i) => {
                    return { text: m, value: m, sortable: false }
                })

                this.results.rows = resultJson;
                return;
            }

            this.snackbar = {
                state: true,
                message: "İşleminiz başarıyla gerçekleştirildi!"
            };

        },
        handleChangeMethodSelection(e) {
            this.selectedMethod = this.userMethods.find(m => m.PROGNAME == e);
            if(this.selectedMethod.MethodParameters.find(m => m.PARAMETER_NAME == 'POP_ID') != null)
                this.selectedMethod["POP_ID"] = this.$store.state.login.agencyDetails.UserName;

            this.results.headers = []
            this.results.rows = []
        },
        handleExportExcelButtonClick() {
            this.exportResultsAsExcel();
        },
        exportResultsAsExcel() {
            let excelColumnsHeaders = [];
            let excelContent = [];
            this.results.headers.map((header, headerIndex) => {
                excelColumnsHeaders.push(header.text);
            });

            excelContent.push(excelColumnsHeaders)

            this.results.rows.map((row, rowIndex) => {

                let rowContentArray = [];
                this.results.headers.forEach((header, headerIndex) => {
                    rowContentArray.push(row[header.text] || "");
                });

                excelContent.push(rowContentArray);
            });
            
            var fileName = this.selectedMethod.PROGNAME + " İşlem Sonucu.xlsx"
            this.downloadExcelFile(fileName, excelContent);
        },
          openDialog(text, header) {
            this.dialogText = text;
            this.dialogHeader = header;
            this.dialog = true;
        },
        formatJson(json) {
            const parsedJson = JSON.parse(json);
            return JSON.stringify(parsedJson, null, 2);
        },
        formatXml(xml) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xml, "application/xml");
            const serializer = new XMLSerializer();
            let formattedXml = serializer.serializeToString(xmlDoc);
            return this.prettyPrintXml(formattedXml);
        },
        prettyPrintXml(xml) {
            const PADDING = '  ';
            let regExp = /(>)(<)(\/*)/g;
            let pad = 0;
            xml = xml.replace(regExp, '$1\n$2$3');
            xml = xml.replace(/\n/g, '\n' + Array(pad + 1).join(PADDING));
            return xml;
        },
        exportBatchResultsAsExcel() {
            let excelColumnsHeaders = [];
            
            this.selectedMethod.MethodParameters.map((header, headerIndex) => {
                excelColumnsHeaders.push(header.PARAMETER_NAME);
            });
            excelColumnsHeaders.push('SONUC');
            
            const excelContent = []
            excelContent.push(excelColumnsHeaders)

            this.batchData.success.map((m, i) => excelContent.push(m))
            this.batchData.failed.map((m, i) => excelContent.push(m))
            this.batchData.problematic.map((m, i) => excelContent.push(m))

            const fileName = this.selectedMethodName + " Toplu İşlem Sonuçları.xlsx";
            this.downloadExcelFile(fileName, excelContent);
        },
        downloadExcelFile(fileName, excelContent) {
            var ws = SheetJS.utils.aoa_to_sheet(excelContent);
            var wb = SheetJS.utils.book_new();
            SheetJS.utils.book_append_sheet(wb, ws, "Sayfa1");
            SheetJS.writeFileXLSX(wb, fileName);
        },
        clearBatchProcess() {
            this.batchStatus = 'idle';
            this.batchProcess = {
                total: 0,
                processed: 0,
                success: 0,
                failed: 0,
                unprocessable: 0
            };
            this.batchParamsMap = {};
            this.batchData = {
                all: [],
                failed: [],
                problematic: [],
                success: [],
            },
            this.batchFile = null;
        }
    },
    async created() {
        this.programDisabled.state = this.getUserCanAccessTeknikAdmin
        this.callGetUserMethods();
    },
}

</script>
<style lang="scss" scoped>
   
.batch-run-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 320px;
    padding: 24px 0;
    align-items: center;
    justify-content: center;

    .file-upload-overlay {
        width: 100%;
        height: auto;
        border: 1px solid #D0D0D0;
        background-color: #FDFDFD;
        border-radius: 6px;
        margin-bottom: 32px;

        &.dragover {
            background-color: #1DB95411;
        }

        &.reading-files {
            animation: readingFileAnim .2s infinite;
        }

        @keyframes readingFileAnim {
            0%    { background-color: #FDFDFD; }
            50%   { background-color: #1DB95411; }
            100%  { background-color: #FDFDFD; }
        }
    }

    .batch-run-loading {
        border-radius: 6px;
        width: 100%;
        height: 320px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        transition: background-color .25s ease-out;
        
        p {
            margin-bottom: 0;
            font-size: 1.25rem;
        }

        i.axa-icon, .batch-progress {
            width: 96px;
            height: 96px;
            transition: color .25s ease-out;
        }

        .batch-progress {
            font-size: 1.5rem;
            font-weight: 700;
        }

        i.axa-icon {
            color: #313949;
        }

        &.batch-error {
            background-color: rgba(255, 0, 0, .05);

            i.axa-icon {
                color: #f00;
            }

            p {
                font-weight: 700;
                color: #f00;
            }
        }

        &.batch-dragover {
            background-color: rgba(255, 255, 0, 0.15);

            i.axa-icon {
                color: #000;
            }

            p {
                font-weight: 700;
                color: #000;
            }
        }

        &.batch-ready {
            background-color: #1DB95411;

            i.axa-icon {
                color: #1DB954;
            }

            p {
                font-weight: 700;
                color: #000;
            }

            button 
            { 
                i.axa-icon 
                {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        &.batch-completed {
            align-items: flex-start;
            justify-content: center;
            padding-left: 32px;
            background-color: #FDFDFD;
        }

        &.batch-processing {
            background-color: rgba(255, 255, 0, 0.15);

            i.axa-icon {
                color: #e6e217;
            }

            p {
                font-weight: 700;
                color: #000;
            }
        }

        &.batch-running {
            background-color: #fb8c0015;

            p {
                font-weight: 700;
                color: #000;                
            }
        }

        .batch-row, .batch-row-header {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;

            i.axa-icon, .batch-progress {
                margin-bottom: 0;

                &.batch-success { color: #1DB954; }
                &.batch-error { color: #F00; }
                &.batch-warning { 
                    color: #E4A11B; 
                }
            }

            p {
                line-height: 1;
            }
        }

        .batch-row {
            gap: 12px;

            i.axa-icon, .batch-progress {
                width: 32px;
                height: 32px;
                margin-bottom: 0;
            }

            p {
                line-height: 1;
                font-size: 1.125rem;
                font-weight: normal;
            }
        }

        .batch-header-row {
            i.axa-icon, .batch-progress {
                display: none;
            }

            p {
                line-height: 1;
                font-size: 1.5rem;
                font-weight: 700;
            }
        }
    }

    .data-requirements {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        
        h3 {
            margin-bottom: 8px;
        }

        ul {
            margin: 0;
            padding: 0;
            margin-left: 16px;
            margin-bottom: 36px;
            width: calc(100% - 16px);
            
            li {
                margin-bottom: 8px;
            }
        }

        table.example-sheet {
            width: 100%;
            margin-top: 8px;

            tr { 
                width: 100%; 
                th,td {
                    text-align: center;
                    text-transform: uppercase;
                    height: 36px;
                }
            }
        }        
    }

}


</style>